<template>
	<div class="content">
		<Head style="padding-left: 20px;">
			<AssetFilter v-model="filter" :def="def" style="position: relative; z-index: 1000;" />
			<div v-if="permissions.userCanCreateAssets()">
				<button class="add" @click="$refs.addMenu.open()">Add Asset <mdi chevron-down /></button>
				<Menu ref="addMenu" style="white-space: nowrap;" right="20px">
					<ul>
						<li @click="singleAssetCreate()">Single asset</li>
						<li @click="$refs.addMedia.open()">Multiple assets</li>
					</ul>
				</Menu>
				<Dialog ref="addMedia">
					<h1>Upload multiple assets</h1>
					<div style="padding: 20px;">
						<AssetMultiUpload @done="$refs.assetTable.filterChanged(true)" />
					</div>
				</Dialog>
			</div>
		</Head>
		<div class="body">
			<!--
			<Filters
				class="filters"
				:currentFilter="filter"
				style="position: fixed; top: 100px; bottom: 0; left: 0; overflow: auto;"
				@setFilter="setFilter"
				name="assetFilters"
			/>
			<div class="entryTableContainer">
			-->
				<AssetTable
					ref="assetTable"
					:filter="filter"
					:selectable="false"
					@input="selected"
					@skipChanged="skipChanged"
					:initialSkip="skip"
				/>
			<!--
			</div>
			-->
		</div>
	</div>
</template>

<script>
import AssetFilter from '../components/fields/AssetFilter.vue'
import AssetTable from '../components/fields/AssetTable.vue'
import Menu from '../components/Menu.vue'
import Dialog from '../components/Dialog.vue'
import Head from './Head.vue'
import ProviderMixin from './ProviderMixin.js'
import AssetMultiUpload from '../components/AssetMultiUpload.vue'
import EntryApiMixin from '../components/EntryApiMixin'
import Filters from './Filters.vue'
import { columnFieldsForColumnIds, newFilterForStorage } from '../components/fields/FilterUtil'

// TODO: load list based on filter

export default {
	name: 'Media',
	mixins: [ ProviderMixin, EntryApiMixin ],
	components: { AssetFilter, AssetTable, Menu, Dialog, Head, AssetMultiUpload, Filters },
	inject: [ 'base', 'endpoint' ],
	data: () => ({
		filter: { search: '', filters: [], order: [ '-sys.updatedAt' ] },
		// TODO: ??
		def: {"id":"x","name":"x","type":"Array","localized":false,"required":false,"validations":[],"disabled":false,"omitted":false,"items":{"type":"Link","validations":[],"linkType":"Entry"}},
		skip: 0,
	}),
	watch: {
		filter: {
			deep: true,
			handler(filter) {
				const query = {
					search: filter.search,
					skip: this.skip,
					filters: filter.filters.map(f => f.storage),
				}
				this.$router.replace({ query }).catch(() => {})
				localStorage['filterQueryMedia'] = JSON.stringify({ ...query, spaceId: this.spaceId, environment: this.environment })
			},
		},
	},
	methods: {
		routerBeforeEach(to, from, next) {
			// TODO: if we only changed the filter -> return here
			next()
		},
		selected(entries) {
			this.$router.push(this.base + '/assets/' + entries[0].sys.id)
		},
		skipChanged(skip) {
			this.skip = skip
			if (this.$route.query.skip == skip) return
			this.$router.push({ query: { ...this.$route.query, skip } })
		},
		async singleAssetCreate() {
			const asset = await this.$httpPost(this.endpoint + '/assets', this.newAsset(), {})
			this.$router.push(this.base + '/assets/' + asset.sys.id)
		},
		setFilter(filter) {
			this.filter.filters = filter.filters
			this.filter.search = filter.search
			this.filter.order = filter.order
		},
	},
	// this needs to happen early, before the table is created so skip is transported there
	created() {
		// TODO-3: add name of space
		document.title = 'Media'

		let view = this.$route.query
		if (!view || Object.keys(view).length == 0) {
			view = JSON.parse(localStorage['filterQueryMedia'] ?? '{}')
			if (view.spaceId != this.spaceId || view.environment != this.environment) view = {}
		}
		if (view) {
			
			// fix query format encoding
			if (!view.filters) view.filters = []
			if (!Array.isArray(view.filters)) view.filters = [view.filters]
			if (view.filters.length > 0 && typeof view.filters[0] == 'string')
				view.filters = view.filters.map(f => f.split(',', 3))

			this.setFilter({
				contentType: view.contentType,
				filters: view.filters?.map?.(f => newFilterForStorage(f)) ?? [],
				search: view.search,
			})

			if (view.skip) this.skip = parseInt(view.skip)
		}
	},
}
</script>

<style scoped>
.EntryFilter { flex-grow: 1; }
h1 { flex-shrink: 0; font-size: 20px; font-weight: 600; margin: 0; padding: 0; width: 250px; padding: 5px 0; }
button.add { white-space: nowrap; background-color: var(--primary); height: 40px; padding: 8px 10px 8px 15px; color: white; border: 0; border-radius: 6px; font-size: 14px; font-weight: 500; cursor: pointer; }
.entryTableContainer { flex-grow: 1; margin: 20px; margin-left: 280px; }

@media (max-width: 800px) {
	.filters { display: none; }
	.entryTableContainer { margin-left: 20px; }
}
</style>